import * as React from "react";
const SvgSkipPrevious = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6V6zm3.5 6 8.5 6V6l-8.5 6z",
  fill: "currentColor"
}));
export default SvgSkipPrevious;